.map {
  background-color: white;
  margin: 0 auto;
  height: 100%;
  width: 100%;
}

.mapContainer {
  position: relative;
  flex: 1;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
